import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const MasterPrivacyPolicy = () => {
  const navigate = useNavigate();

  const sections = [
    {
      title: "MASTER PRIVACY POLICY",
      content: `Effective Date: 1.02.2026

Welcome to AICA HEALTH (“AICA”, “we”, “our”, or “us”).

This Privacy Policy explains how AICA collects, processes, stores, transfers, and protects personal data across:
aicahealth.com, qcare.aicahealth.com, rx.aicahealth.com, apps, kiosks, APIs, conversational AI systems, and related services.`,
    },

    {
      title: "1. Data We May Collect",
      content: `We may collect:
• demographic information
• contact information
• physiological data
• biometric-derived data
• optical sensing data
• image-derived data
• voice inputs
• symptom information
• medication-related information
• behavioral interaction data
• screening history
• device identifiers
• usage analytics
• enterprise wellness data
• associated metadata`,
    },

    {
      title: "2. Purpose of Processing",
      content: `We process data for:
• preventive healthcare engagement
• physiological inference
• wellness support
• symptom tracking
• medication adherence support
• AI-assisted analysis
• care coordination support
• model refinement
• calibration systems
• analytics and research
• product improvement
• security and fraud prevention
• regulatory compliance`,
    },

    {
      title: "3. AI & Automated Processing",
      content: `Certain features use AI, machine learning, and automated inference systems.

Outputs may be:
• probabilistic
• inference-based
• calibration-dependent

Users acknowledge AI-generated insights are informational only.`,
    },

    {
      title: "4. Data Sharing",
      content: `We may share data with:
• authorized healthcare providers
• enterprise customers
• hospitals
• cloud service providers
• analytics vendors
• subprocessors
• legal/regulatory authorities (when required)

We DO NOT sell personal data.`,
    },

    {
      title: "5. Cross-Border Processing",
      content: `Data may be stored or processed:
• within India
• internationally via secure cloud infrastructure
• authorized service providers`,
    },

    {
      title: "6. Data Security",
      content: `We implement:
• encryption
• access control
• authentication systems
• security monitoring

No system is fully secure or immune to breaches.`,
    },

    {
      title: "7. Data Retention",
      content: `Data is retained only as necessary for:
• operational needs
• legal compliance
• security requirements
• validation and analytics

Some data may be anonymized for AI model improvement and research.`,
    },

    {
      title: "8. User Rights",
      content: `Users may:
• request access to data
• request correction
• withdraw consent
• request deletion (where legally allowed)

Requests can be sent to the Grievance Officer.`,
    },

    {
      title: "9. Children’s Data",
      content: `The Platform is not intended for users under 18 without parental or guardian consent.`,
    },

    {
      title: "10. Governing Law",
      content: `This Privacy Policy is governed by Indian law, including the Digital Personal Data Protection Act, 2023.`,
    },

    {
      title: "11. Contact & Grievance Officer",
      content: `AICA HEALTH
Email: a@aicahealth.com

Grievance Officer
Regd Address:
1st Floor, D-48, Ajay Enclave,
New Delhi - 110018`,
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-500 via-green-400 to-blue-300 text-white relative overflow-hidden">

      {/* Background Glow */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-cyan-400/20 blur-3xl rounded-full"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-emerald-400/20 blur-3xl rounded-full"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 py-10">

        {/* HEADER */}
        <div className="text-center mb-10">
          <h1 className="text-4xl sm:text-5xl font-bold">
            Privacy Policy
          </h1>
          <p className="text-white/80 mt-2">
            MASTER DATA PRIVACY FRAMEWORK — AICA HEALTH
          </p>
        </div>

        {/* CONTENT */}
        <div className="space-y-6">

          {sections.map((sec, i) => (
            <div
              key={i}
              className="bg-white/10 border border-white/20 rounded-2xl p-6 backdrop-blur-xl shadow-lg hover:bg-white/15 transition-all"
            >
              <h2 className="text-xl font-semibold mb-3 text-white">
                {sec.title}
              </h2>

              <p className="text-white/80 whitespace-pre-line leading-relaxed text-sm sm:text-base">
                {sec.content}
              </p>
            </div>
          ))}

        </div>

        {/* FOOTER */}
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-white/20 pt-6">

          <p className="text-white/70 text-sm">
            © {new Date().getFullYear()} AICA HEALTH TECH Pvt Ltd
          </p>

          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 px-5 py-2 bg-white text-teal-700 font-semibold rounded-xl shadow hover:bg-gray-200 transition"
          >
            <ArrowLeft size={18} />
            Go Back
          </button>

        </div>
      </div>
    </div>
  );
};

export default MasterPrivacyPolicy;